import { render, staticRenderFns } from "./AssignMeasurementModal.vue?vue&type=template&id=22a690f4&"
import script from "./AssignMeasurementModal.vue?vue&type=script&lang=js&"
export * from "./AssignMeasurementModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignMeasurementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports